import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Logo from './Logo';

const HeaderContainer = styled.header`
  background: ${props => props.theme.colors.backgroundSoft};
  box-shadow: ${props => props.theme.shadows.warm};
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1000;
  padding: 1rem 0;
  border-bottom: 2px solid ${props => props.theme.colors.borderLight};
`;

const HeaderContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;


const Nav = styled.nav`
  display: flex;
  gap: 2rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavLink = styled(Link)`
  color: ${props => props.theme.colors.text};
  font-weight: 500;
  transition: color 0.3s ease;

  &:hover {
    color: ${props => props.theme.colors.primary};
  }
`;

const Header: React.FC = () => {
  return (
    <HeaderContainer role="banner">
      <HeaderContent>
        <Logo />
        <Nav role="navigation" aria-label="ניווט ראשי">
          <NavLink to="/" aria-label="עבור לעמוד הבית">בית</NavLink>
          <NavLink to="/about" aria-label="עבור לקטע אודות">אודות</NavLink>
          <NavLink to="/services" aria-label="עבור לקטע שירותים">שירותים</NavLink>
          <NavLink to="/contact" aria-label="עבור לקטע צור קשר">צור קשר</NavLink>
        </Nav>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default Header;